import { Link } from "react-router-dom";
import { ServiceTypeSelectorOption } from "../../../types/order";

interface Props {
  to: string;
  imagePath?: string;
  label: string;
  service:ServiceTypeSelectorOption
  onClickService: (service: ServiceTypeSelectorOption)=> void
}

const ServiceCard = ({ to, imagePath, label, service,  onClickService }: Props) => {
  return (
    <Link onClick={()=> {onClickService(service)}} to={to} className="no-underline w-full">
      <div className="relative bg-[#E5E5E5] rounded-lg p-2 text-center">
        <div
          className={`bg-cover bg-center rounded-lg relative h-24`}
          style={{
            backgroundImage: `url(${imagePath})`,
          }}
        >
          <span className="absolute bottom-0 left-0 right-0 overflow-hidden truncate rounded-b-lg bg-foreground/50 py-1 text-center text-sm font-bold tracking-[0.02rem] text-background px-1">
            {label}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ServiceCard;
